module.exports = __webpack_public_path__ + "img/white_whatsapp.da9e28b5.svg";